export const VIDEO_TYPES = ['mp4', 'avi', 'mov', 'webm'];
export const CONTENT_TYPES = ['post', 'story', 'banner', 'push_notification', 'reportage', 'popup', 'add'];
